const fetchWithTimeout = (url: string, options?: any, timeout = 30000):Promise<any> => {
    return Promise.race([
        fetch(url, options),
        new Promise((_, reject) =>
            setTimeout(() => reject(new Error('timeout')), timeout)
        )
    ]);
}

export default fetchWithTimeout